export const AppPathConfig = {
  languagePath: "/track-and-trace/assets/languages",
  configurationPath: "/track-and-trace/assets/configuration",
  hubPathName: "/my-apps/",
  appRouteBaseURL: "track-and-trace/",
  localhostString: "http://localhost",
  launchDarkly: {
    featureFlag: "apmt-tnt-auth",
    appName: "tnt",
    subHeading: "Track and Trace"
  }
};
